import { createFileRoute, Outlet } from "@tanstack/react-router"

import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute(
  "/_authenticated/account/saved-payment-methods"
)({
  staticData: {
    pageName: "Saved Payment Methods",
  },
  loader: () => {
    return {
      crumb: { translationKey: "common:account.title" } as Crumb,
    }
  },
  component: Outlet,
})
